import api from "./axios";

const usersApi = {
  /**
   * Fetches the currently signed-in user. Mirrors buyer's
   * `usersApis.getCurrentUser()` → `GET /users/currentUser`.
   */
  getCurrentUser: async (): Promise<any> => {
    const { data } = await api.get("/users/currentUser");
    return data;
  },

  /**
   * Returns the modules this user is allowed to see in the launcher.
   * Used by the shell Home page to filter the module grid.
   */
  getUserAccessibleModules: async (): Promise<any> => {
    const { data } = await api.get("/users/getUserAccessibleModules");
    return data;
  },
};

export default usersApi;
